import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Card, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { formatOptionalField } from "@/pages/manage-vehicles/utils/formatOptionalField";

const columns = [
  {
    flex: 1,
    field: "car_id",
    headerName: "Car Id",
    valueGetter: (params) => params.row.car_id,
  },
  {
    flex: 1,
    field: "make",
    headerName: "Make",
    valueGetter: (params) => params.row.make,
  },

  {
    flex: 1,
    field: "model",
    headerName: "Model",
    valueGetter: (params) => params.row.model,
  },

  {
    flex: 1,
    field: "grade",
    headerName: "Grade",
    valueGetter: (params) => params.row.grade,
  },

  {
    flex: 1,
    field: "engine",
    headerName: "Engine",
    valueGetter: (params) => params.row.engine,
  },

  {
    flex: 1,
    field: "power",
    headerName: "Power",
    valueGetter: (params) => params.row.power,
  },

  {
    flex: 1,
    field: "speed",
    headerName: "speed",
    valueGetter: (params) => params.row.speed,
  },

  {
    flex: 1,
    field: "battery",
    headerName: "Battery",
    minWidth: 100,
    sortable: false,
    valueGetter: (params) => params.row.battery,
    renderCell: (params) => formatOptionalField(params.row.battery),
  },

  {
    flex: 1,
    field: "towing",
    headerName: "Towing",
    minWidth: 100,
    sortable: false,
    valueGetter: (params) => params.row.towing,
    renderCell: (params) => formatOptionalField(params.row.towing),
  },

  {
    flex: 1,
    field: "view",
    headerName: "View",
    sortable: false,
    minWidth: 90,
    headerAlign: "center",
    align: "center",
    // flex: 1,
    disableClickEventBubbling: true,
    renderCell: () => {
      return <Button variant="outlined">View</Button>;
    },
  },
];

const VehicleListing = ({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  handleSelectCar,
}) => {
  function handleCellClick(params) {
    console.log(params);

    if (params.field === "view") {
      handleSelectCar(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          // sx={{ width: "100%", overflowX: "scroll" }}
          rows={data?.vehicleList}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
        />
      </Box>
    </Card>
  );
};

export default VehicleListing;

VehicleListing.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.any,
  data: PropTypes.shape({
    offerTrackerList: PropTypes.arrayOf(
      PropTypes.shape({
        make: PropTypes.string,
        linkAddress: PropTypes.string,
        linkText: PropTypes.string,
        modelsText: PropTypes.string,
        offer: PropTypes.string,
        offerText: PropTypes.string,
        offerTitle: PropTypes.string,
      })
    ),
  }),
  rowCountState: PropTypes.number,
  paginationModel: PropTypes.shape({
    pageSize: PropTypes.number,
    page: PropTypes.number,
  }),
  setPaginationModel: PropTypes.func,
};
